<fieldset [formGroup]="parentFormGroup">
  <legend>
    <div>
      <span i18n>Exam Type</span>
      <div>
        <eas-editor-booking-item-inheritable-type-badge *ngIf="itemTreeExamTypeForm.value !== null" [inheritableType]="'set'">
        </eas-editor-booking-item-inheritable-type-badge>
        <button *ngIf="isDeletable()"
          mat-icon-button
          aria-label="Delete exam type"
          i18n-aria-label
          (click)="onDelete()">
          <mat-icon inline>delete</mat-icon>
        </button>
      </div>
    </div>
  </legend>
  <p i18n>
    Please define the type of the exam you are creating,
    define the connection to the exam delivery system and the risr/assess blueprint to use.
  </p>
  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label i18n>Select exam type for College exam</mat-label>
      <mat-select id="exam-type" formControlName="examType">
        <mat-option value=""><em i18n></em></mat-option>
        <mat-option *ngFor="let option of examTypeNames" [value]="option.id">
          {{ option.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <p i18n *ngIf="isLoftOsceSelected()" class="subtitle-help-text">
      Individual on demand oral exam requires one candidate and one examiner. Please ensure an examiner is specified during the workflow and associated workflow action to create exam in risr/assess.
    </p>

    <mat-form-field appearance="outline" *ngIf="isRisrAssessExamType()">
      <mat-label i18n>Select risr/assess instance for exam delivery</mat-label>
      <mat-select id="connection-id" formControlName="risrAssessConnectionId" required>
        <mat-option value=""><em i18n></em></mat-option>
        <mat-option *ngFor="let connection of risrAssessConnections" [value]="connection.id">
          {{ connection.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="parentFormGroup.get('risrAssessConnectionId')?.errors?.required" i18n>
        risr/assess connection is required
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" *ngIf="isRisrConnectionSelected()">
      <mat-label i18n>Select risr/assess exam blueprint
        <mat-progress-spinner *ngIf="areBlueprintsLoading" diameter="16" mode="indeterminate" color="primary"
                              style="vertical-align: middle;"></mat-progress-spinner>
      </mat-label>
      <mat-select id="risr-assess-blueprint-id" formControlName="risrAssessBlueprintId"
                  [required]="isLoftExamType()" [disabled]="areBlueprintsLoading">
        <mat-option value=""><em i18n></em></mat-option>
        <mat-option *ngFor="let blueprint of risrAssessBlueprints" [value]="blueprint.id">
          {{ blueprint.name }}
        </mat-option>
        <mat-option *ngIf="!risrAssessBlueprints || risrAssessBlueprints?.length === 0" disabled>
          <em i18n>No mapped risr/advance blueprints available</em>
        </mat-option>
      </mat-select>
      <mat-error *ngIf="parentFormGroup.get('risrAssessBlueprintId')?.errors?.required" i18n>
        risr/assess blueprint is required for Individual on demand exam type
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="isRisrConnectionSelected() && isLoftExamType()">
      <mat-label i18n>Item set generation method</mat-label>
      <mat-select id="item-set-selection-method" formControlName="risrAssessItemSetGenerationMethod" required>
        <mat-option [value]="'autogenerated'" i18n>Autogenerated</mat-option>
        <mat-option [value]="'specific'" i18n>Choose specific item set</mat-option>
      </mat-select>
      <mat-error *ngIf="parentFormGroup.get('risrAssessItemSetGenerationMethod')?.errors?.required" i18n>
        Selecting an item set generation method is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="isRisrAssessItemSetGenerationMethodSelected()">
      <mat-label i18n>
        {{ parentFormGroup.get('risrAssessItemSetGenerationMethod')?.value === 'autogenerated' ? 'Select risr/assess backup itemset' : 'Select risr/assess itemset' }}
        <mat-progress-spinner *ngIf="areItemSetsLoading" diameter="16" mode="indeterminate" color="primary"
                              style="vertical-align: middle;"></mat-progress-spinner>
      </mat-label>
      <mat-select id="risr-assess-itemset" formControlName="risrAssessItemSetNumber" [required]="true"
                  [disabled]="areItemSetsLoading">
        <mat-option value=""><em i18n></em></mat-option>
        <mat-option *ngFor="let itemset of risrAssessItemSets" [value]="itemset.id">
          {{ itemset.name }}
        </mat-option>
        <mat-option *ngIf="!risrAssessItemSets || risrAssessItemSets?.length === 0" disabled>
          <em i18n>No itemsets available</em>
        </mat-option>
      </mat-select>
      <mat-error *ngIf="parentFormGroup.get('risrAssessItemSetNumber')?.errors?.required" i18n>
        risr/assess itemset is required for Individual on demand exam type
      </mat-error>
    </mat-form-field>
  </div>
</fieldset>
